import { Box, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { green } from "@mui/material/colors";

const BENEFITS = [
  {
    primary: "Appear more professional when reaching out to brands",
    secondary:
      "Bento sets up SPF, DKIM, and DMARC for you to improve email deliverability",
  },
  {
    primary:
      "Significantly reduce the chance of getting blocked or marked as spam",
    secondary:
      "You maintain control to recover access, and Bento helps you detect and fix issues!",
  },
  {
    primary:
      "If you've been using Outlook, Hotmail, or another email provider, you can now create a custom domain and start using Bento seamlessly",
    secondary:
      "This will also better isolate your pitching emails from your personal emails",
  },
];

export default function CustomEmailBenefits() {
  return (
    <List disablePadding>
      {BENEFITS.map((benefit, index) => (
        <ListItem sx={{ py: 0 }} key={index}>
          <ListItemIcon sx={{ minWidth: "35px" }}>
            <Box
              component="i"
              sx={{ color: green[500] }}
              className="fa-solid fa-square-check"
            />
          </ListItemIcon>
          <ListItemText
            primary={benefit.primary}
            secondary={benefit.secondary}
          />
        </ListItem>
      ))}
    </List>
  );
}
